
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDamperHorizontalOffLarge as ObiDamperHorizontalOffLargeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-damper-horizontal-off-large.js';
 
 
 

 
 export const ObiDamperHorizontalOffLarge = createComponent({
   react: React,
   tagName: 'obi-damper-horizontal-off-large',
   elementClass: ObiDamperHorizontalOffLargeElement,
   events: {
     
   }
  });
 
 